(function () {
  var toastTimer;

  function showToast(msg) {
    var toast = document.getElementById('bsb-toast');
    document.getElementById('bsb-toast-msg').textContent = msg;
    toast.classList.add('bsb-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('bsb-toast--visible');
    }, 2800);
  }

  // Add-to-cart buttons — add the selected bundle product to the Shopify cart.
  // The variant id comes from the product chosen in the theme editor (block settings).
  // If no product is assigned yet (e.g. local preview), it just shows the toast.
  document.querySelectorAll('.bsb-add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var name = this.dataset.name || 'Bundle';
      var variantId = this.dataset.variantId;

      // No product wired up yet — show confirmation only.
      if (!variantId) {
        showToast(name + ' added to cart');
        return;
      }

      var button = this;
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            showToast((result.data && result.data.description) || "Couldn't add to cart — please try again");
            return;
          }
          showToast(name + ' added to cart');
          // Update Dawn's header cart count bubble(s) if present.
          fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              document
                .querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child')
                .forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });
        })
        .catch(function () {
          showToast("Couldn't add to cart — please try again");
        })
        .finally(function () {
          if (button.dataset.variantAvailable !== 'false') button.disabled = false;
        });
    });
  });

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return '$' + (Number(cents) / 100).toFixed(2);

    function withDelimiters(number, precision, thousands, decimal) {
      var num = (Number(number) / 100).toFixed(precision || 2);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
      return parts.join(decimal || '.');
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function getSelectedOptions(picker) {
    var selected = {};
    var variantSelects = picker.querySelector('variant-selects');
    if (!variantSelects) return selected;

    variantSelects.querySelectorAll('[data-option-group]').forEach(function (group) {
      var position = group.dataset.optionGroup;
      var checked = group.querySelector('input:checked');
      if (checked) selected['option' + position] = checked.value;
    });
    return selected;
  }

  function findVariant(variants, selected) {
    return variants.find(function (variant) {
      return Object.keys(selected).every(function (key) {
        return variant[key] === selected[key];
      });
    });
  }

  function updateBundleVariant(bundleSection, variant, moneyFormat) {
    var priceEl = bundleSection.querySelector('[data-price]');
    var compareEl = bundleSection.querySelector('[data-compare-price]');
    var saveBadge = bundleSection.querySelector('[data-save-badge]');
    var addBtn = bundleSection.querySelector('.bsb-add-to-cart');
    if (!variant) return;

    if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (saveBadge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        saveBadge.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price, moneyFormat);
        saveBadge.hidden = false;
      } else {
        saveBadge.hidden = true;
      }
    }

    if (addBtn) {
      addBtn.dataset.variantId = variant.id;
      addBtn.dataset.variantAvailable = variant.available ? 'true' : 'false';
      addBtn.disabled = !variant.available;
    }
  }

  function isOptionValueAvailable(variants, selected, optionKey, optionValue) {
    return variants.some(function (variant) {
      if (variant[optionKey] !== optionValue) return false;
      return (
        Object.keys(selected).every(function (key) {
          if (key === optionKey) return true;
          return !selected[key] || variant[key] === selected[key];
        }) && variant.available
      );
    });
  }

  function updateOptionAvailability(picker, variants) {
    var selected = getSelectedOptions(picker);

    picker.querySelectorAll('[data-option-group]').forEach(function (group) {
      var position = group.dataset.optionGroup;
      var optionKey = 'option' + position;

      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var available = isOptionValueAvailable(variants, selected, optionKey, input.value);
        var isPill = group.classList.contains('product-form__input--pill');

        if (isPill) {
          input.disabled = !available;
          input.classList.toggle('disabled', !available);
        } else {
          input.disabled = false;
          input.classList.toggle('visually-disabled', !available);
        }
      });
    });
  }

  function selectOptionValue(picker, optionPosition, value) {
    var group = picker.querySelector('[data-option-group="' + optionPosition + '"]');
    if (!group) return;
    var input = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (el) {
      return el.value === value;
    });
    if (!input) return;
    input.checked = true;
    input.classList.remove('visually-disabled', 'disabled');
    input.disabled = false;

    var label = group.querySelector('[data-selected-value]');
    if (label) label.textContent = value;
  }

  function ensureCompatibleSelection(picker, variants, changedOptionKey) {
    var selected = getSelectedOptions(picker);
    if (findVariant(variants, selected) && findVariant(variants, selected).available) {
      return selected;
    }

    // Prefer keeping the option the shopper just changed; adjust the other option(s).
    var changedValue = selected[changedOptionKey];
    var candidate = variants.find(function (variant) {
      if (!variant.available) return false;
      if (changedValue && variant[changedOptionKey] !== changedValue) return false;
      return true;
    });

    if (!candidate) {
      candidate = variants.find(function (variant) {
        return variant.available;
      });
    }
    if (!candidate) return selected;

    Object.keys(selected).forEach(function (key) {
      var position = key.replace('option', '');
      if (candidate[key] && candidate[key] !== selected[key]) {
        selectOptionValue(picker, position, candidate[key]);
      }
    });

    return getSelectedOptions(picker);
  }

  function handleVariantChange(picker, variants, moneyFormat, bundleSection, changedOptionKey) {
    if (changedOptionKey) {
      ensureCompatibleSelection(picker, variants, changedOptionKey);
    }
    updateOptionAvailability(picker, variants);
    var selected = getSelectedOptions(picker);
    var variant = findVariant(variants, selected);
    if (variant && bundleSection) updateBundleVariant(bundleSection, variant, moneyFormat);
  }

  document.querySelectorAll('[data-bundle-picker]').forEach(function (picker) {
    var variantsJson = picker.querySelector('[data-variants-json]');
    if (!variantsJson) return;

    var variants = JSON.parse(variantsJson.textContent);
    var moneyFormat = picker.dataset.moneyFormat;
    var bundleSection = picker.closest('[data-bundle]');
    var variantSelects = picker.querySelector('variant-selects');

    if (!variantSelects) return;

    variantSelects.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio') return;

      var group = input.closest('[data-option-group]');
      var changedOptionKey = group ? 'option' + group.dataset.optionGroup : null;

      // Allow selecting a finish that isn't available with the current size;
      // ensureCompatibleSelection will switch size to a valid combo.
      input.classList.remove('visually-disabled', 'disabled');
      input.disabled = false;

      handleVariantChange(picker, variants, moneyFormat, bundleSection, changedOptionKey);
    });

    updateOptionAvailability(picker, variants);
  });

  // FAQ accordion
  document.querySelectorAll('.bsb-faq__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.bsb-faq__item');
      var isOpen = item.classList.contains('bsb-faq__item--open');
      document.querySelectorAll('.bsb-faq__item').forEach(function (i) {
        i.classList.remove('bsb-faq__item--open');
        i.querySelector('.bsb-faq__btn').setAttribute('aria-expanded', 'false');
        i.querySelector('.bsb-faq__sign').textContent = '+';
      });
      if (!isOpen) {
        item.classList.add('bsb-faq__item--open');
        btn.setAttribute('aria-expanded', 'true');
        btn.querySelector('.bsb-faq__sign').textContent = '−';
      }
    });
  });
})();
